import { StackedIcon } from '@/fontawesome';
import { SettingsBase } from '../settings/SettingsBase';
import type { PinnedViewParams } from './PinnedViewParams';

export class PinnedViewsSettings extends SettingsBase {
    static NAME_OF_CLASS = 'PinnedViewsSettings';
    public pinnedViews: PinnedViewParams[] = [];

    public constructor(val?: PinnedViewsSettings) {
        super();
        this.pinnedViews = val?.pinnedViews ?? [];
        this.pinnedViews.forEach((view) => {
            // fix for correct class
            if (view.icon && typeof view.icon !== 'string') {
                // this is a stacked icon
                view.icon = StackedIcon.FromStackedIcon(view.icon);
            }
        });
    }
}
